import React from 'react'
import Videosection from '../Menhome/Videosection'
import Special from '../Menhome/Special'
import Contact from '../Menhome/Contact'
import Banner from '../Menhome/Banner'
import Offer from '../Menhome/Offer'
import Story from '../Menhome/Story'
import Specialdish from '../Menhome/Specialdish'
import LiveSports from '../Menhome/LiveSports'
import Menusection from '../Menhome/Menusection'
import Whyus from '../Menhome/Whyus'
import Feature from '../Menhome/Feature'
import PageSEO from '../SEO/PageSEO'

const FAQ_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What are Huq Up hours?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Huq Up - Cafe & Grill is open Sunday through Thursday from 11 AM to 2 AM, and Friday and Saturday from 11 AM to 3 AM.'
      }
    },
    {
      '@type': 'Question',
      name: 'Where is Huq Up located?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Huq Up - Cafe & Grill is located at 27052 E University Dr Suite 100, Little Elm, TX 75068, in the DFW area.'
      }
    },
    {
      '@type': 'Question',
      name: 'Does Huq Up have hookah?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes! Huq Up has a full hookah lounge with over 70 flavors. Guests must be 21 or older to order hookah or alcohol.'
      }
    },
    {
      '@type': 'Question',
      name: 'Can I make a reservation at Huq Up?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, you can make a reservation by calling (469) 724-1846 or booking online at huqup380.com/reservation.'
      }
    },
    {
      '@type': 'Question',
      name: 'Does Huq Up show live sports?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes! Huq Up features live sports on the biggest screen in the DFW area.'
      }
    },
    {
      '@type': 'Question',
      name: 'What type of food does Huq Up serve?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Huq Up serves a diverse menu including Indian cuisine (biryanis, kababs), burgers, wraps, Mediterranean dishes, pasta, artisan pizzas, specialty coffees, teas, mocktails, and more.'
      }
    }
  ]
}

function Main() {
    return (
        <>
            <PageSEO
              title="Little Elm TX | Dine-In, Hookah & Live Sports"
              description="Huq Up - Cafe & Grill in Little Elm, TX. Fresh ingredients, bold spices & family recipes served daily until 2 AM. Dine-in, hookah lounge, live sports on the biggest screen in DFW."
              canonical="https://www.huqup380.com/"
              structuredData={FAQ_SCHEMA}
            />
            <div className="menu-backdrop"> </div>
            <Banner />
            <Offer />
            <Story />
            <LiveSports />
            <Specialdish />
            <Menusection />
            <Special />
            <Contact />
            <Whyus />
            <Feature />
            {/* <Teem /> */}
            <Videosection />
            {/* <Reacntupdate /> */}
        </>
    )
}

export default Main
